import React from 'react';
import { motion } from 'framer-motion';
import { MessageSquare, Instagram, MapPin, Mail, Phone } from 'lucide-react';

const Footer = () => {
  const currentYear = 2025;

  const footerSections = [
    {
      title: 'Support',
      links: ['Help Center', 'Contact Us', 'FAQs', 'Terms of Service'],
    },
    {
      title: 'Legal',
      links: ['Privacy Policy', 'Cookie Policy', 'Terms & Conditions', 'Refund Policy'],
    },
  ];

  const socialIcons = [
    { icon: MessageSquare, url: 'https://wa.me/917036242781', title: 'WhatsApp' },
    { icon: Instagram, url: 'https://www.instagram.com/galoba_dietbox?igsh=Y3dwdHdqOWRlZzg0' },
  ];

  return (
    <footer className="bg-dark-text text-white py-16">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-12">
          {/* Brand Section */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }} 
          >
            <h3 className="text-2xl font-poppins font-bold text-primary mb-4">GALOBA</h3>
            <p className="text-gray-300 mb-4">Fuel Your Gains with premium diet food delivery.</p>
            <div className="flex gap-4">
              {socialIcons.map((social, index) => (
                <motion.a
                  key={index}
                  href={social.url}
                  whileHover={{ scale: 1.2, color: '#2ECC71' }}
                  className="text-gray-300 hover:text-primary transition-colors"
                  title={social.title || 'Social Media'}
                >
                  <social.icon size={20} />
                </motion.a>
              ))}
            </div>
          </motion.div>

          {/* Footer Links */}
          {footerSections.map((section, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
            >
              <h4 className="font-poppins font-semibold mb-4">{section.title}</h4>
              <ul className="space-y-2">
                {section.links.map((link, linkIndex) => (
                  <li key={linkIndex}>
                    <button className="text-gray-300 hover:text-primary transition-colors">
                      {link}
                    </button>
                  </li>
                ))}
              </ul>
            </motion.div>
          ))}

          {/* Contact Info */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.3 }}
          >
            <h4 className="font-poppins font-semibold mb-4">Contact</h4>
            <div className="space-y-3">
              <div className="flex items-center gap-2">
                <Phone size={18} className="text-primary" />
                <span className="text-gray-300">+91 95427 04244</span>
              </div>
              <div className="flex items-center gap-2">
                <Mail size={18} className="text-primary" />
                <span className="text-gray-300">galobadiet@gmail.com</span>
              </div>
              <div className="flex items-center gap-2">
                <MapPin size={18} className="text-primary" />
                <span className="text-gray-300">Kukatpally, Hyderabad, Telangana</span>
              </div>
            </div>
          </motion.div>
        </div>

        {/* Divider */}
        <div className="border-t border-gray-700 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-300 text-sm">
              © {currentYear} GALOBA. All rights reserved.
            </p>
            <div className="flex gap-6 mt-4 md:mt-0">
              <button className="text-gray-300 hover:text-primary text-sm transition-colors">
                Privacy Policy
              </button>
              <button className="text-gray-300 hover:text-primary text-sm transition-colors">
                Terms of Service
              </button>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
